mutation UpdateStreamEntrypoint($id: ID!, $input: UpdateStreamEntrypointInput!) {
  updateStreamEntrypoint(id: $id, input: $input) {
    id
    title
  }
}
